import React from "react";
import { Flex, Text, FileObjectType } from "@jsq/ds/core";
import { Colors, Sizes } from "@jsq/ds/styles";
import FileCard from "../FileCard";
import * as uploadStyles from "../styles_vanilla.css";

interface FileWithType {
  file: FileObjectType;
  dataType?: string;
}

interface FileConfigurationSectionProps {
  filesWithTypes: FileWithType[];
  getAvailableDataTypes: (
    currentFileDataType?: string,
  ) => Array<{ value: string; label: string }>;
  onDataTypeChange: (fileName: string, dataType: string | number | string[] | number[]) => void;
  onRemoveFile: (fileName: string) => void;
}

const FileConfigurationSection: React.FC<FileConfigurationSectionProps> = ({
  filesWithTypes,
  getAvailableDataTypes,
  onDataTypeChange,
  onRemoveFile,
}) => {
  if (filesWithTypes.length === 0) {
    return null;
  }

  return (
    <Flex className={uploadStyles.fileConfigSection} flexDirection="column" gap={Sizes.MD}>
      <Flex className={uploadStyles.fileConfigHeader} flexDirection="column" gap={Sizes.XS}>
        <Text variant="strong-lg" color={Colors.Neutral900}>
          Configure Your Files
        </Text>
        <Text variant="regular-md" className={uploadStyles.subtitleText}>
          Select the data type for each file to ensure proper processing.
        </Text>
        <Text variant="regular-sm" className={uploadStyles.fileCount}>
          {filesWithTypes.length} file{filesWithTypes.length !== 1 ? "s" : ""} selected
        </Text>
      </Flex>

      <Flex flexDirection="column" gap={Sizes.SM}>
        {filesWithTypes.map((item) => (
          <FileCard
            key={item.file.file.name}
            file={item.file}
            dataType={item.dataType}
            availableDataTypes={getAvailableDataTypes(item.dataType)}
            onDataTypeChange={onDataTypeChange}
            onRemoveFile={onRemoveFile}
          />
        ))}
      </Flex>
    </Flex>
  );
};

export default FileConfigurationSection;
